import { isCapture } from 'chessboard/model/move/is-capture';
import { isCastle } from 'chessboard/model/move/is-castle';
import { isCheck } from 'chessboard/model/move/is-check';
import { isPromotion } from 'chessboard/model/move/is-promotion';
import type { Game } from 'chessboard/model/game/types';
import { Sounds } from 'chessboard/plugins/sounds/config/types';

/**
 * Get the sound type from the move.
 */
export function getSoundType(
  move: Game.Move.Node,
  isOpponentMove: boolean,
): Sounds.BoardSounds | null {
  if (!move || !move.san) {
    return null;
  }

  let sound: Sounds.BoardSounds;

  if (isCheck(move)) {
    sound = Sounds.BoardSounds.MoveCheck;
  } else if (move.isPremove) {
    sound = Sounds.BoardSounds.Premove;
  } else if (isPromotion(move)) {
    sound = Sounds.BoardSounds.Promote;
  } else if (isCapture(move)) {
    sound = Sounds.BoardSounds.Capture;
  } else if (isCastle(move)) {
    sound = Sounds.BoardSounds.Castle;
  } else {
    sound = isOpponentMove ? Sounds.BoardSounds.MoveOpponent : Sounds.BoardSounds.MoveSelf;
  }

  return sound;
}
